export class Signature {
    id: number;
    imageUrl: string;
    ibBooking: string;
    rating: number;
    constructor() {
        this.id = 0;
        this.imageUrl = '';
        this.ibBooking = '';
        this.rating = 0;
    }
}
